import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, createBlock as _createBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "resource h-full w-full" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "masonry" }
const _hoisted_4 = { class: "masonry-content" }
const _hoisted_5 = { class: "masonry" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "masonry-content" }
const _hoisted_8 = { class: "image-slot flex items-center justify-center w-full h-full" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = {
  key: 0,
  class: "select-indicator"
}
const _hoisted_11 = {
  key: 1,
  class: "select-indicator",
  style: {"border":"1px solid #2a66ff","background-color":"#2a66ff"}
}
const _hoisted_12 = {
  key: 0,
  class: "hover-actions"
}
const _hoisted_13 = {
  key: 3,
  class: "caption"
}
const _hoisted_14 = { class: "caption-text" }
const _hoisted_15 = {
  key: 0,
  class: "masonry"
}
const _hoisted_16 = { class: "masonry-content" }
const _hoisted_17 = {
  key: 2,
  class: "w-full h-full flex items-center justify-center"
}
const _hoisted_18 = { class: "detail flex items-center w-[100vw] h-[100vh]" }
const _hoisted_19 = { class: "left h-full w-[calc(100%-400px)] border-r border-[#eee]" }
const _hoisted_20 = { class: "top h-[80px] border-b border-[#eee] bg-white px-[20px] flex items-center justify-between" }
const _hoisted_21 = { class: "r flex items-center gap-[10px]" }
const _hoisted_22 = { class: "bottom h-[calc(100%-80px)] bg-[#f5f7fa]" }
const _hoisted_23 = { class: "preview-center" }
const _hoisted_24 = ["src"]
const _hoisted_25 = { class: "right w-[400px] h-full" }
const _hoisted_26 = { class: "bottom h-[calc(100%-80px)] bg-white overflow-auto" }
const _hoisted_27 = { class: "p-[20px]" }
const _hoisted_28 = { class: "sec" }
const _hoisted_29 = { class: "name-box" }
const _hoisted_30 = { class: "sec" }
const _hoisted_31 = { class: "info-card" }
const _hoisted_32 = { class: "info-row" }
const _hoisted_33 = { class: "info-value" }
const _hoisted_34 = { class: "info-row" }
const _hoisted_35 = { class: "info-value" }
const _hoisted_36 = { class: "info-row" }
const _hoisted_37 = { class: "info-value" }
const _hoisted_38 = { class: "info-row" }
const _hoisted_39 = { class: "info-value" }
const _hoisted_40 = {
  key: 0,
  class: "sec"
}
const _hoisted_41 = { class: "sec-muted" }
const _hoisted_42 = { class: "sec" }
const _hoisted_43 = {
  key: 0,
  class: "sec-muted"
}
const _hoisted_44 = {
  key: 1,
  class: "side-tags"
}

import { ElButton, ElIcon, ElEmpty, ElScrollbar, ElDropdown, ElDropdownMenu, ElDropdownItem, ElMessageBox, ElMessage, ElDialog, ElSkeleton, ElSkeletonItem } from 'element-plus'
import { Star, MoreFilled } from '@element-plus/icons-vue'
import { ref, onMounted, watch, computed } from 'vue'
import { getResourceList } from '@/api/affairs'
import { useSdkStore } from '@/stores/sdk'
import { multipleChoiceStore } from "@/stores/multipleChoice"
import MoveDialog from '@/views/shared/components/MoveDialog.vue'
import { folderOperate, resourceDetail, resourceFav } from '@/api/ResourceMasonry'

export default /*@__PURE__*/_defineComponent({
  __name: 'ResourceMasonry',
  props: {
  id: { type: Number, default: 0 },
  corpCode: { type: String, default: '' },
  showUploadWhenEmpty: { type: Boolean, default: false },
  rootLabel: { type: String, default: '' }
},
  emits: ['upload'],
  setup(__props, { expose: __expose, emit: __emit }) {

const sdkStore = useSdkStore()
const multipleChoice = multipleChoiceStore()
const desginsdk = sdkStore.getSdk()
//@ts-ignore
const selectedResources = computed(() => multipleChoice.getSelectedResources())
const selectedSet = computed(() => new Set(selectedResources.value))
const multipleChoiceShow = computed(() => multipleChoice.multipleChoice)
const isResourcesSelected = (id: any) => {
  return selectedSet.value.has(id)
}

const onSelect = (item: any) => {
  multipleChoice.setselectedResources(item.id)
}

const selectonClick = (item: any) => {
  if (multipleChoiceShow.value) {
    onSelect(item)
  }
}



const props = __props
const emit = __emit

const resourceList = ref<any[]>([])
const pageNum = ref(1)
const pageSize = ref(50)
const hasMore = ref(true)
const initialLoading = ref(false)
const loadingMore = ref(false)
const totalPage = ref(0)
const currentFolder = ref<{ id: string | number | undefined }>({ id: '' })
const file_type = ref<string | number | ''>('')
const category_id = ref<string | number | ''>('')
const file_suffix = ref<string | number | ''>('')
const tag_ids = ref<string | number | ''>('')
const searchText = ref<string | number | ''>('')

onMounted(() => {
  getList()
})

watch(() => props.id, (newVal, oldVal) => {
  if (newVal != oldVal) {
    pageNum.value = 1
    hasMore.value = true
    getList(false)
  }
})
const edittemplate = (_item: any) => {
  window.open(`/editor?id=${_item.id}&mode=user`)
}
const getList = (append = false) => {

  if (append && loadingMore.value) return
  if (append) loadingMore.value = true
  if (!append) initialLoading.value = true
  const params: any = {
    page: pageNum.value,
    size: pageSize.value,
    file_type: file_type.value,
    folder_id: currentFolder.value?.id || '',
    category_id: category_id.value || '',
    file_suffix: file_suffix.value || '',
    tag_ids: tag_ids.value || '',
    keyword: searchText.value || '',
    is_single: 1,
    owner_type: props.corpCode ? 'team' : 'user',
  }

  if (props.corpCode) params.corp_code = props.corpCode
  getResourceList(params).then(res => {
    multipleChoice.clearSelected()
    const items = res?.data?.data?.items || []
    totalPage.value = res?.data?.data?.total_pages || 0
    if (append) resourceList.value = (resourceList.value || []).concat(items)
    else resourceList.value = items
    hasMore.value = items.length === pageSize.value
  }).finally(() => {
    loadingMore.value = false
    if (!append) initialLoading.value = false
  })
}

const parentgetList = (f: any) => {
  if (f?.currentFolder) currentFolder.value = f.currentFolder
  if (f?.file_type === '' || f?.file_type) file_type.value = f.file_type
  if (f?.category_id === '' || f?.category_id) category_id.value = f.category_id
  if (f?.file_suffix === '' || f?.file_suffix) file_suffix.value = f.file_suffix
  if (f?.tag_ids === '' || f?.tag_ids) tag_ids.value = f.tag_ids
  if (f?.search === '' || f?.search) searchText.value = f.search

  pageNum.value = 1
  hasMore.value = true
  getList(false)
}
__expose({ getList, parentgetList })


const onFav = (_item: any) => {
  let params = {
    owner_type: props.corpCode ? 'team' : 'user',
    target_type: 5,
    target_id: _item.id,
    folder_id: '',
    corp_code: props.corpCode
  }
  resourceFav(params).then(res => {
    if (res?.data?.code === 0) {
      _item.is_favorite = !_item.is_favorite
      ElMessage.success('操作成功')
    }
  })
}
const moveVisible = ref(false)
const moveAction = ref<'move' | 'copy'>('move')
const selectedItem = ref<any>(null)
const detailVisible = ref(false)
const detailItem = ref<any>(null)
const detailStatic = ref()
const onItemCommand = (cmd: string, item: any) => {
  if (cmd === 'detail') { detailItem.value = item; onDetailConfirm(); return }
  if (cmd === 'download') { onDownload(item); return }
  if (cmd === 'move') { selectedItem.value = item; moveAction.value = 'move'; moveVisible.value = true; return }
  if (cmd === 'copy') { selectedItem.value = item; moveAction.value = 'copy'; moveVisible.value = true; return }
  if (cmd === 'edit') { edittemplate(item); return }
  if (cmd === 'delete') {
    deleteResource(item)
    return
  }
}
const copyResource = (item: any) => {

  selectedItem.value = item; moveAction.value = 'copy'; moveVisible.value = true; return
}
const moveResource = (item: any) => {
  selectedItem.value = item; moveAction.value = 'move'; moveVisible.value = true; return
}
const deleteResource = (item: any) => {
  console.log(item)
  ElMessageBox.confirm(`确认删除资源“${item.name || item.file_name || ''}”？删除后不可恢复`, '删除资源', {
    confirmButtonText: '删除',
    cancelButtonText: '取消',
    type: 'warning'
  }).then(async () => {
    try {
      await folderOperate({ kind: 'resource', action: 'delete', resource_id: item.id, owner_type: props.corpCode ? 'team' : 'user', corp_code: props.corpCode })
      resourceList.value = resourceList.value.filter(x => x.id !== item.id)
      ElMessage.success('资源已删除')
      detailVisible.value = false
    } catch { }
  }).catch(() => { })
}
const onDetailConfirm = () => {
  resourceDetail({ resource_id: detailItem.value.id, corp_code: props.corpCode, owner_type: props.corpCode ? 'team' : 'user' }).then(res => {
    const item = res?.data?.data || {}
    detailStatic.value = item
    detailVisible.value = true
  })
}

const onMoveConfirm = () => {
  pageNum.value = 1
  hasMore.value = true
  getList(false)
}
const onDownload = (item: any) => {
  console.log(item)
  const url = item?.full_preview_url
  if (url) window.open(url, '_blank')
}

const onScroll = (e: string) => {
  if (pageNum.value >= totalPage.value) return
  if (e == 'bottom') {
    pageNum.value += 1
    getList(true)
  }
}
const scrollbarRef = ref<any>(null)
const scrollWrapEl = computed(() => scrollbarRef.value?.wrapRef as HTMLElement | undefined)
const optimizeImageUrl = (url: any, w = 400, q = 80) => {
  const s = String(url || '')
  if (!s) return s
  const lower = s.toLowerCase()
  const isSvg = lower.endsWith('.svg') || lower.includes('.svg?') || lower.includes('format=svg')
  if (isSvg) return s
  const proc = `x-oss-process=image/resize,w_${w}/quality,q_${q}/format,webp`
  return s.includes('?') ? `${s}&${proc}` : `${s}?${proc}`
}
const getPreviewSrc = (item: any) => optimizeImageUrl(item?.full_preview_url, 400, 80)
const getDetailPreviewSrc = (item: any) => optimizeImageUrl(item?.full_preview_url, 1600, 85)

return (_ctx: any,_cache: any) => {
  const _component_Loading = _resolveComponent("Loading")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_Check = _resolveComponent("Check")!
  const _component_CloseBold = _resolveComponent("CloseBold")!
  const _component_DeleteFilled = _resolveComponent("DeleteFilled")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_DocumentCopy = _resolveComponent("DocumentCopy")!
  const _component_Right = _resolveComponent("Right")!
  const _component_Download = _resolveComponent("Download")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (initialLoading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(20, (n) => {
              return _createElementVNode("div", {
                key: n,
                class: "masonry-item"
              }, [
                _createElementVNode("div", _hoisted_4, [
                  _createVNode(_unref(ElSkeleton), {
                    loading: true,
                    animated: ""
                  }, {
                    template: _withCtx(() => [
                      _createVNode(_unref(ElSkeletonItem), {
                        variant: "image",
                        style: {"width":"100%","height":"100%"}
                      })
                    ]),
                    _: 1
                  })
                ])
              ])
            }), 64))
          ])
        ]))
      : (resourceList.value.length > 0)
        ? (_openBlock(), _createBlock(_unref(ElScrollbar), {
            key: 1,
            ref_key: "scrollbarRef",
            ref: scrollbarRef,
            height: "100%",
            onEndReached: onScroll,
            distance: 100
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_5, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(resourceList.value, (item) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: item.id,
                    class: _normalizeClass(["masonry-item cursor-pointer", { 'selectborder': isResourcesSelected(item.id) }]),
                    onClick: ($event: any) => (selectonClick(item))
                  }, [
                    _createElementVNode("div", _hoisted_7, [
                      _createVNode(_component_el_image, {
                        src: getPreviewSrc(item),
                        class: "media",
                        fit: "cover",
                        lazy: true,
                        "scroll-container": scrollWrapEl.value
                      }, {
                        placeholder: _withCtx(() => [
                          _createElementVNode("div", _hoisted_8, [
                            _createVNode(_unref(ElIcon), null, {
                              default: _withCtx(() => [
                                _createVNode(_component_Loading)
                              ]),
                              _: 1
                            })
                          ])
                        ]),
                        _: 1
                      }, 8, ["src", "scroll-container"]),
                      _createElementVNode("div", {
                        class: _normalizeClass(["select", { 'multipleChoiceShow': multipleChoiceShow.value }]),
                        onClick: _withModifiers(($event: any) => (onSelect(item)), ["stop"])
                      }, [
                        (!isResourcesSelected(item.id))
                          ? (_openBlock(), _createElementBlock("span", _hoisted_10))
                          : (_openBlock(), _createElementBlock("span", _hoisted_11, [
                              _createVNode(_unref(ElIcon), { color: "white" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_Check)
                                ]),
                                _: 1
                              })
                            ]))
                      ], 10, _hoisted_9),
                      (!multipleChoiceShow.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                            _createVNode(_unref(ElDropdown), {
                              trigger: "click",
                              onCommand: (cmd) => onItemCommand(cmd, item)
                            }, {
                              dropdown: _withCtx(() => [
                                _createVNode(_unref(ElDropdownMenu), { style: {"width":"120px"} }, {
                                  default: _withCtx(() => [
                                    _createVNode(_unref(ElDropdownItem), { command: "detail" }, {
                                      default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                                        _createTextVNode("详情 ", -1)
                                      ]))]),
                                      _: 1
                                    }),
                                    (item.file_type == '2')
                                      ? (_openBlock(), _createBlock(_unref(ElDropdownItem), {
                                          key: 0,
                                          command: "download"
                                        }, {
                                          default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                                            _createTextVNode("下载", -1)
                                          ]))]),
                                          _: 1
                                        }))
                                      : _createCommentVNode("", true),
                                    (item.file_type == '1')
                                      ? (_openBlock(), _createBlock(_unref(ElDropdownItem), {
                                          key: 1,
                                          command: "edit"
                                        }, {
                                          default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                                            _createTextVNode("编辑", -1)
                                          ]))]),
                                          _: 1
                                        }))
                                      : _createCommentVNode("", true),
                                    _createVNode(_unref(ElDropdownItem), { command: "move" }, {
                                      default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                                        _createTextVNode("移动", -1)
                                      ]))]),
                                      _: 1
                                    }),
                                    _createVNode(_unref(ElDropdownItem), { command: "copy" }, {
                                      default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                                        _createTextVNode("复制", -1)
                                      ]))]),
                                      _: 1
                                    }),
                                    _createVNode(_unref(ElDropdownItem), { command: "delete" }, {
                                      default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                                        _createTextVNode("删除", -1)
                                      ]))]),
                                      _: 1
                                    })
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              default: _withCtx(() => [
                                _createElementVNode("span", {
                                  class: "action-btn",
                                  onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
                                }, [
                                  _createVNode(_unref(ElIcon), null, {
                                    default: _withCtx(() => [
                                      _createVNode(_unref(MoreFilled))
                                    ]),
                                    _: 1
                                  })
                                ])
                              ]),
                              _: 2
                            }, 1032, ["onCommand"])
                          ]))
                        : _createCommentVNode("", true),
                      (item.file_type == '2' && !multipleChoiceShow.value)
                        ? (_openBlock(), _createBlock(_unref(ElButton), {
                            key: 1,
                            class: "download-btn",
                            type: "primary",
                            onClick: _withModifiers(($event: any) => (onDownload(item)), ["stop"])
                          }, {
                            default: _withCtx(() => [...(_cache[15] || (_cache[15] = [
                              _createTextVNode("下载", -1)
                            ]))]),
                            _: 1
                          }, 8, ["onClick"]))
                        : _createCommentVNode("", true),
                      (item.file_type == '1' && !multipleChoiceShow.value)
                        ? (_openBlock(), _createBlock(_unref(ElButton), {
                            key: 2,
                            class: "download-btn",
                            type: "primary",
                            onClick: _withModifiers(($event: any) => (edittemplate(item)), ["stop"])
                          }, {
                            default: _withCtx(() => [...(_cache[16] || (_cache[16] = [
                              _createTextVNode("编辑", -1)
                            ]))]),
                            _: 1
                          }, 8, ["onClick"]))
                        : _createCommentVNode("", true),
                      (!multipleChoiceShow.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                            _createElementVNode("span", _hoisted_14, _toDisplayString(item.name || item.file_name ||
              ''), 1)
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ], 10, _hoisted_6))
                }), 128))
              ]),
              (loadingMore.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(10, (n) => {
                      return _createElementVNode("div", {
                        key: 's-' + n,
                        class: "masonry-item"
                      }, [
                        _createElementVNode("div", _hoisted_16, [
                          _createVNode(_unref(ElSkeleton), {
                            loading: true,
                            animated: ""
                          }, {
                            template: _withCtx(() => [
                              _createVNode(_unref(ElSkeletonItem), {
                                variant: "image",
                                style: {"width":"100%","height":"100%"}
                              })
                            ]),
                            _: 1
                          })
                        ])
                      ])
                    }), 64))
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 512))
        : (_openBlock(), _createElementBlock("div", _hoisted_17, [
            _createVNode(_unref(ElEmpty), { description: "暂无数据" }, {
              default: _withCtx(() => [
                (__props.showUploadWhenEmpty)
                  ? (_openBlock(), _createBlock(_unref(ElButton), {
                      key: 0,
                      type: "primary",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('upload')))
                    }, {
                      default: _withCtx(() => [...(_cache[17] || (_cache[17] = [
                        _createTextVNode("本地上传", -1)
                      ]))]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ])),
    _createVNode(_unref(ElDialog), {
      modelValue: detailVisible.value,
      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((detailVisible).value = $event)),
      title: "",
      "align-center": "",
      fullscreen: "",
      "show-close": false,
      style: {"padding":"0"}
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("div", {
                class: "l cursor-pointer",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (detailVisible.value = false))
              }, [
                _createVNode(_unref(ElIcon), null, {
                  default: _withCtx(() => [
                    _createVNode(_component_CloseBold)
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_21, [
                _createVNode(_component_el_tooltip, {
                  class: "box-item",
                  effect: "dark",
                  content: "删除",
                  placement: "top-end"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", {
                      class: "w-[40px] flex align-center justify-center cursor-pointer",
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (deleteResource(detailItem.value)))
                    }, [
                      _createVNode(_unref(ElIcon), { size: "20" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_DeleteFilled)
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_tooltip, {
                  class: "box-item",
                  effect: "dark",
                  content: "复制",
                  placement: "top-end"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", {
                      class: "w-[40px] flex align-center justify-center cursor-pointer",
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (copyResource(detailItem.value)))
                    }, [
                      _createVNode(_unref(ElIcon), { size: "20" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_DocumentCopy)
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_tooltip, {
                  class: "box-item",
                  effect: "dark",
                  content: "移动",
                  placement: "top-end"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", {
                      class: "w-[40px] flex align-center justify-center cursor-pointer",
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (moveResource(detailItem.value)))
                    }, [
                      _createVNode(_unref(ElIcon), { size: "20" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_Right)
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_tooltip, {
                  class: "box-item",
                  effect: "dark",
                  content: "下载",
                  placement: "top-end"
                }, {
                  default: _withCtx(() => [
                    (detailItem.value.file_type == '2')
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          class: "w-[40px] flex align-center justify-center cursor-pointer",
                          onClick: _cache[6] || (_cache[6] = ($event: any) => (onDownload(detailItem.value)))
                        }, [
                          _createVNode(_unref(ElIcon), { size: "20" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_Download)
                            ]),
                            _: 1
                          })
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("div", _hoisted_23, [
                (detailItem.value?.full_preview_url)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      src: getDetailPreviewSrc(detailItem.value),
                      class: "big-preview"
                    }, null, 8, _hoisted_24))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_25, [
            _cache[26] || (_cache[26] = _createElementVNode("div", { class: "top h-[80px] border-b border-[#eee] flex items-center px-[20px] bg-white" }, [
              _createElementVNode("span", { class: "title text-[16px] font-bold" }, "详情")
            ], -1)),
            _createElementVNode("div", _hoisted_26, [
              _createElementVNode("div", _hoisted_27, [
                _createElementVNode("div", _hoisted_28, [
                  _cache[18] || (_cache[18] = _createElementVNode("div", { class: "sec-title" }, "文件名称", -1)),
                  _createElementVNode("div", _hoisted_29, _toDisplayString(detailStatic.value.resource.name), 1)
                ]),
                _createElementVNode("div", _hoisted_30, [
                  _cache[23] || (_cache[23] = _createElementVNode("div", { class: "sec-title" }, "基本信息", -1)),
                  _createElementVNode("div", _hoisted_31, [
                    _createElementVNode("div", _hoisted_32, [
                      _cache[19] || (_cache[19] = _createElementVNode("span", { class: "info-label" }, "资源尺寸", -1)),
                      _createElementVNode("span", _hoisted_33, _toDisplayString(detailStatic.value.resource.width) + " * " + _toDisplayString(detailStatic.value.resource.height), 1)
                    ]),
                    _createElementVNode("div", _hoisted_34, [
                      _cache[20] || (_cache[20] = _createElementVNode("span", { class: "info-label" }, "资源格式", -1)),
                      _createElementVNode("span", _hoisted_35, _toDisplayString(detailStatic.value.resource.full_preview_url.split('.').pop() || ''), 1)
                    ]),
                    _createElementVNode("div", _hoisted_36, [
                      _cache[21] || (_cache[21] = _createElementVNode("span", { class: "info-label" }, "资源大小", -1)),
                      _createElementVNode("span", _hoisted_37, _toDisplayString(detailStatic.value.resource.file_size_mb) + "MB", 1)
                    ]),
                    _createElementVNode("div", _hoisted_38, [
                      _cache[22] || (_cache[22] = _createElementVNode("span", { class: "info-label" }, "上传时间", -1)),
                      _createElementVNode("span", _hoisted_39, _toDisplayString(detailStatic.value.
                    resource.created_time), 1)
                    ])
                  ])
                ]),
                (detailStatic.value.categories[0])
                  ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                      _cache[24] || (_cache[24] = _createElementVNode("div", { class: "sec-title" }, "分类 ", -1)),
                      _createElementVNode("div", _hoisted_41, _toDisplayString(detailStatic.value.categories[0].name || ''), 1)
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_42, [
                  _cache[25] || (_cache[25] = _createElementVNode("div", { class: "sec-title flex items-center justify-between" }, [
                    _createElementVNode("span", null, "标签")
                  ], -1)),
                  (!detailStatic.value.tags.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_43, "未关联标签"))
                    : (_openBlock(), _createElementBlock("div", _hoisted_44, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(detailStatic.value.tags, (t) => {
                          return (_openBlock(), _createElementBlock("span", {
                            class: "tag-chip",
                            key: t
                          }, _toDisplayString(t.name), 1))
                        }), 128))
                      ]))
                ])
              ])
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(MoveDialog, {
      modelValue: moveVisible.value,
      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((moveVisible).value = $event)),
      type: 'resource',
      "corp-code": props.corpCode,
      current: { folder_id: currentFolder.value.value?.id || '' },
      resource: selectedItem.value,
      action: moveAction.value,
      teams: [{ team_name: __props.rootLabel, team_id: props.corpCode, }],
      onConfirm: onMoveConfirm
    }, null, 8, ["modelValue", "corp-code", "current", "resource", "action", "teams"])
  ]))
}
}

})